import { TemplateEngine } from "../../utils/TemplateEngine.js";
import { LcapiiService } from "../../services/LcapiiService.js";
import { RegistroService } from "../../services/RegistroService.js";
import { operacionesPermitidas } from "../../../operaciones/permisos.js";
import { canInstall, triggerInstall } from "../../../installApp.js";
import navbarTemplate from "./navbar.html?raw";

// El navbar se arma desde el registro de operaciones y muestra solo las
// secciones con permiso. La app anterior listaba las nueve para todo el mundo y
// recién al entrar rebotaba a "no disponible".

export const Navbar = {
  render(claveActiva = "") {
    const sesion = LcapiiService.sesion();
    const pendientes = RegistroService.pendientes();

    return TemplateEngine.render(navbarTemplate, {
      nombres: sesion.nombres || "Usuario",
      urlFoto: sesion.urlFoto || "",
      urlCambiarClave: LcapiiService.urlCambiarClave(),
      claseInicio: claveActiva === "" ? "active" : "",
      operaciones: operacionesPermitidas().map((op) => ({
        clave: op.clave,
        titulo: op.titulo,
        clase: op.clave === claveActiva ? "active" : "",
      })),
      pendientes: String(pendientes),
      hayPendientes: pendientes > 0,
      enGracia: !LcapiiService.hayValidacionFresca(),
    });
  },

  /** Se llama después de cada innerHTML, porque el nodo se recrea. */
  bind() {
    document.getElementById("btnLogout")?.addEventListener("click", (e) => {
      e.preventDefault();
      LcapiiService.logout();
    });

    // "Instalar app" solo cuando hay con qué: el prompt de Android ya capturado
    // o Safari en iPhone. Para quien cerró el banner y después se arrepiente.
    const btnInstalar = document.getElementById("btnInstalar");
    if (btnInstalar && canInstall()) {
      btnInstalar.classList.remove("d-none");
      btnInstalar.addEventListener("click", async (e) => {
        e.preventDefault();
        await triggerInstall();
      });
    }
  },
};
